import React, { useCallback, useEffect, useState } from 'react';

export default function NeuroterapeutasScreen({ token, tenant }) {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  const fetchUsuarios = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
  const res = await fetch(`https://api.braineka.com/usuarios?tenant_id=${tenant.id}&role=psicologo`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Error al cargar neuroterapeutas');
      const data = await res.json();
      setUsuarios(Array.isArray(data) ? data : []);
    } catch (err) {
      setError('Error cargando neuroterapeutas: ' + (err.message || ''));
    } finally {
      setLoading(false);
    }
  }, [tenant.id, token]);

  useEffect(() => { fetchUsuarios(); }, [fetchUsuarios]);

  const startEdit = u => {
    setEditId(u.id);
    setEditForm({ ...u });
  };
  const handleEditInput = e => setEditForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handleEditSave = async e => {
    e.preventDefault();
    setError('');
    try {
  const res = await fetch(`https://api.braineka.com/usuarios/${editId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(editForm)
      });
      if (!res.ok) throw new Error('Error al editar neuroterapeuta');
      setEditId(null); setEditForm({});
      fetchUsuarios();
    } catch (err) {
      setError('Error editando: ' + (err.message || ''));
    }
  };
  const handleEditCancel = () => { setEditId(null); setEditForm({}); };

  const actualizar = (id, accion) => async () => {
    setError('');
  let url = `https://api.braineka.com/usuarios/${id}/`;
    if (accion === 'habilitar') url += 'aprobar';
    else if (accion === 'deshabilitar') url += 'deshabilitar';
  else if (accion === 'borrar') url = `https://api.braineka.com/usuarios/${id}`;
    try {
      const res = await fetch(url, {
        method: accion === 'borrar' ? 'DELETE' : 'PUT',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Error en la acción');
      fetchUsuarios();
    } catch (e) {
      setError('Error actualizando usuario: ' + (e.message || ''));
    }
  };

  if (loading) return <div>Cargando neuroterapeutas...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (usuarios.length === 0) return <div>No hay neuroterapeutas registrados.</div>;

  return (
    <div>
      <h3>Neuroterapeutas registrados</h3>
      <table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th>Especialidad</th>
            <th>Habilitado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map(u => editId === u.id ? (
            <tr key={u.id}>
              <td><input name="nombre" value={editForm.nombre || ''} onChange={handleEditInput} /></td>
              <td><input name="email" value={editForm.email || ''} onChange={handleEditInput} /></td>
              <td><input name="telefono" value={editForm.telefono || ''} onChange={handleEditInput} /></td>
              <td><input name="especialidad" value={editForm.especialidad || ''} onChange={handleEditInput} /></td>
              <td>{Number(u.habilitado || 0) ? 'Sí' : 'No'}</td>
              <td>
                <button onClick={handleEditSave}>Guardar</button>
                <button onClick={handleEditCancel}>Cancelar</button>
              </td>
            </tr>
          ) : (
            <tr key={u.id}>
              <td>{u.nombre || ''}</td>
              <td>{u.email || ''}</td>
              <td>{u.telefono || ''}</td>
              <td>{u.especialidad || ''}</td>
              <td>{Number(u.habilitado || 0) ? 'Sí' : 'No'}</td>
              <td>
                {!Number(u.habilitado || 0) && <button onClick={actualizar(u.id, 'habilitar')}>Habilitar</button>}
                {Number(u.habilitado || 0) && <button onClick={actualizar(u.id, 'deshabilitar')}>Deshabilitar</button>}
                <button onClick={() => startEdit(u)}>Editar</button>
                <button onClick={actualizar(u.id, 'borrar')}>Borrar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
